module.exports = __webpack_public_path__ + "img/tickets.7c82bc91.svg";